import { validatePresence, validateLength } from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence({ message: 'content_pillars.validations.pillars.title.presence', presence: true }),
    validateLength({ message: 'content_pillars.validations.pillars.title.length', min: 5, max: 100 })
  ]
};
